const topics = [
  { name: '明星塌房', count: 1280, hot: true, icon: 'ri-user-star-line' },
  { name: '网红翻车', count: 965, hot: true, icon: 'ri-live-line' },
  { name: '综艺内幕', count: 847, hot: true, icon: 'ri-tv-2-line' },
  { name: '影视爆料', count: 732, hot: false, icon: 'ri-film-line' },
  { name: '企业黑幕', count: 689, hot: false, icon: 'ri-building-line' },
  { name: '社会热点', count: 654, hot: true, icon: 'ri-fire-line' },
  { name: '财经内幕', count: 598, hot: false, icon: 'ri-line-chart-line' },
  { name: '科技泄密', count: 521, hot: false, icon: 'ri-cpu-line' },
  { name: '教育丑闻', count: 476, hot: false, icon: 'ri-book-open-line' },
  { name: '体育风波', count: 432, hot: false, icon: 'ri-basketball-line' },
  { name: '直播乱象', count: 415, hot: true, icon: 'ri-vidicon-line' },
];

export default function Topics() {
  return (
    <section id="topics" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <span className="text-sm text-accent-600 font-medium bg-accent-50 px-3 py-1 rounded-full">话题标签</span>
          <h2 className="mt-3 text-2xl md:text-3xl font-heading font-bold text-foreground-950">热门话题</h2>
          <p className="mt-2 text-sm text-foreground-500">探索你最感兴趣的话题领域</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic, index) => (
            <a
              key={index}
              href="#updates"
              className={`inline-flex items-center gap-2.5 px-5 py-3 rounded-xl border transition-all duration-200 cursor-pointer group whitespace-nowrap ${
                topic.hot
                  ? 'bg-primary-50 border-primary-200 hover:bg-primary-100 hover:border-primary-300'
                  : 'bg-background-50 border-background-200/70 hover:border-secondary-300 hover:bg-secondary-50'
              }`}
            >
              <span className={`w-8 h-8 flex items-center justify-center rounded-lg ${topic.hot ? 'bg-primary-100 text-primary-600' : 'bg-secondary-100 text-secondary-600'}`}>
                <i className={`${topic.icon} text-base`}></i>
              </span>
              <span className="text-sm font-medium text-foreground-800">{topic.name}</span>
              <span className="text-xs text-foreground-400">{topic.count}条</span>
              {topic.hot && (
                <span className="text-[10px] px-1.5 py-0.5 bg-primary-500 text-background-50 rounded-full flex items-center gap-0.5">
                  <i className="ri-fire-line text-[8px]"></i>热
                </span>
              )}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}